const colors = {
    pastellblau: "#89b1cd",
    pastellgruen: "#7fb896",
    pastellrot: "#ff8D8D",
    iconAndTextGrey: "#757575",
    iconAndTextGreyDisabled: "#AAA",
    pastellgelb: "#eebd2b",
}

export default colors;